var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9302 7.77C17.8602 7.76 17.7902 7.76 17.7202 7.77C16.1702 7.72 14.9402 6.45 14.9402 4.89C14.9402 3.3 16.2302 2 17.8302 2C19.4202 2 20.7202 3.29 20.7202 4.89C20.7102 6.45 19.4802 7.72 17.9302 7.77Z",
    fill: "#017EA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1901 14.6999C20.0701 15.4499 18.5001 15.7299 17.0501 15.5399C17.4301 14.7199 17.6301 13.8099 17.6401 12.8499C17.6401 11.8499 17.4201 10.8999 17.0001 10.0699C18.4801 9.86991 20.0501 10.1499 21.1801 10.8999C22.7601 11.9399 22.7601 13.6499 21.1901 14.6999Z",
    fill: "#017EA7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84018 7.77C6.91018 7.76 6.98018 7.76 7.05018 7.77C8.60018 7.72 9.83018 6.45 9.83018 4.89C9.83018 3.29 8.54018 2 6.94018 2C5.35018 2 4.06018 3.29 4.06018 4.89C4.06018 6.45 5.29018 7.72 6.84018 7.77Z",
    fill: "#017EA7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95026 12.8501C6.95026 13.8201 7.16026 14.7401 7.54026 15.5701C6.13026 15.7201 4.66026 15.4201 3.58026 14.7101C2.00026 13.6601 2.00026 11.9501 3.58026 10.9001C4.65026 10.1801 6.16026 9.8901 7.58026 10.0501C7.17026 10.8901 6.95026 11.8401 6.95026 12.8501Z",
    fill: "#017EA7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5202 15.87C12.4402 15.86 12.3502 15.86 12.2602 15.87C10.4202 15.81 8.9502 14.3 8.9502 12.44C8.9602 10.54 10.4902 9 12.4002 9C14.3002 9 15.8402 10.54 15.8402 12.44C15.8302 14.3 14.3702 15.81 12.5202 15.87Z",
    fill: "#017EA7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2702 17.9396C7.7602 18.9496 7.7602 20.6096 9.2702 21.6096C10.9902 22.7596 13.8102 22.7596 15.5302 21.6096C17.0402 20.5996 17.0402 18.9396 15.5302 17.9396C13.8202 16.7896 11.0002 16.7896 9.2702 17.9396Z",
    fill: "#017EA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.dca7dfaa4eb3b9c2b667b0b894152c87.svg";
export { ForwardRef as ReactComponent };